import ICONS from './svgs.js'

/**
 * @param {{ name: string, size?: number, className?: string, style?: React.CSSProperties }} props
 */
export function Icon({ name, size = 24, className = '', style }) {
  const inner = ICONS[name]
  if (!inner) return null
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.75"
      strokeLinecap="square"
      strokeLinejoin="miter"
      className={className}
      style={style}
      aria-hidden="true"
      dangerouslySetInnerHTML={{ __html: inner }}
    />
  )
}
